export default "__VITE_ASSET__COx$2vfa__"